import { useMemo, useState } from 'react';
import { filterCollectionBySearch, filterProvidersBySelectedScopes } from '~/helpers/utils';
import type { ProviderSummary } from '~/types/Provider';

export function useProviderFilters(providers: ProviderSummary[]) {
  const [search, setSearch] = useState('');
  const [selectedScopes, setSelectedScopes] = useState<string[]>([]);

  const filteredProviders = useMemo(() => {
    let results = filterCollectionBySearch(providers, search);
    if (selectedScopes.length > 0) {
      results = results.filter((provider) =>
        filterProvidersBySelectedScopes(provider, selectedScopes)
      );
    }
    return results;
  }, [providers, search, selectedScopes]);

  return {
    search,
    setSearch,
    selectedScopes,
    setSelectedScopes,
    filteredProviders,
  };
}